import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { resetState } from '../../../store/actions';
import { RootState } from '../../../store/store';

export interface RequestState {
  activeRequestId: string | null;
}

const initialState: RequestState = {
  activeRequestId: null,
};

export const requestsSlice = createSlice({
  name: 'requests',
  initialState,
  reducers: {
    setActiveRequestId: (state, { payload }: PayloadAction<string | null>) => {
      state.activeRequestId = payload;
    },
  },
  extraReducers: builder => {
    builder.addMatcher(resetState.match, () => initialState);
  },
});

export const selectActiveRequestId = (state: RootState) => state.requests.activeRequestId;

export const { setActiveRequestId } = requestsSlice.actions;

const requestsReducer = requestsSlice.reducer;

export default requestsReducer;
